import { render, staticRenderFns } from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=template&id=56cd53cc&scoped=true"
import script from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue?vue&type=style&index=0&id=56cd53cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd53cc",
  null
  
)

export default component.exports